import api from './api';
import { ProgressStep, ProgressStepFormData, ProgressStepListResponse } from '../types/progressStep';

export const progressStepService = {
  // Get all progress steps for a project
  getAll: async (
    workspaceId: string,
    projectId: string
  ): Promise<ProgressStepListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/projects/${projectId}/progress-steps`);
    return response.data;
  },

  // Get published progress steps (for purchaser portal)
  getPublished: async (
    workspaceId: string,
    projectId: string
  ): Promise<ProgressStepListResponse> => {
    const response = await api.get(`/workspaces/${workspaceId}/projects/${projectId}/progress-steps/published`);
    return response.data;
  },

  // Get single progress step
  getById: async (workspaceId: string, id: string): Promise<ProgressStep> => {
    const response = await api.get(`/workspaces/${workspaceId}/progress-steps/${id}`);
    return response.data;
  },

  // Create progress step
  create: async (
    workspaceId: string,
    projectId: string,
    data: ProgressStepFormData
  ): Promise<ProgressStep> => {
    const response = await api.post(
      `/workspaces/${workspaceId}/projects/${projectId}/progress-steps`,
      data
    );
    return response.data;
  },

  // Update progress step
  update: async (
    workspaceId: string,
    id: string,
    data: Partial<ProgressStepFormData>
  ): Promise<ProgressStep> => {
    const response = await api.put(
      `/workspaces/${workspaceId}/progress-steps/${id}`,
      data
    );
    return response.data;
  },

  // Delete progress step
  delete: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/progress-steps/${id}`);
  },

  // Reorder progress steps
  reorder: async (
    workspaceId: string,
    projectId: string,
    stepId: string,
    direction: 'up' | 'down'
  ): Promise<void> => {
    await api.post(
      `/workspaces/${workspaceId}/projects/${projectId}/progress-steps/reorder`,
      { stepId, direction }
    );
  }
};
